export default __webpack_public_path__ + "static/media/knex.141aea5d.svg";